import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7081/RpData";
	}
	hasAccess(e) {
		let t = this.baseUrl + "/HasAccess";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processHasAccess(e)));
	}
	processHasAccess(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getComparableProperties(e, t, n, r, i, a, o, s, c, l) {
		let u = this.baseUrl + "/GetComparableProperties?";
		if (e == null) throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
		if (u += "page=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
		u += "pageSize=" + encodeURIComponent("" + t) + "&", n != null && (u += "propertyId=" + encodeURIComponent("" + n) + "&"), r != null && (u += "radius=" + encodeURIComponent("" + r) + "&"), i != null && (u += "minBedrooms=" + encodeURIComponent("" + i) + "&"), a != null && (u += "maxBedrooms=" + encodeURIComponent("" + a) + "&"), o != null && (u += "propertyType=" + encodeURIComponent("" + o) + "&"), s != null && (u += "latitude=" + encodeURIComponent("" + s) + "&"), c != null && (u += "longitude=" + encodeURIComponent("" + c) + "&"), u = u.replace(/[?&]$/, "");
		let d = {
			method: "GET",
			url: u,
			headers: { Accept: "application/json" },
			signal: l
		};
		return this.transformOptions(d).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(u, e, (e) => this.processGetComparableProperties(e)));
	}
	processGetComparableProperties(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPropertySummary(e, t, n) {
		let r = this.baseUrl + "/GetPropertySummary?";
		if (e == null) throw new globalThis.Error("The parameter 'address' must be defined and cannot be null.");
		r += "address=" + encodeURIComponent("" + e) + "&", t != null && (r += "propertyId=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPropertySummary(e)));
	}
	processGetPropertySummary(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	addressSuggestion(e, t, n) {
		let r = this.baseUrl + "/AddressSuggestion?";
		if (e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (r += "query=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		r += "state=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processAddressSuggestion(e)));
	}
	processAddressSuggestion(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t === 500) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	planSuggestion(e, t, n) {
		let r = this.baseUrl + "/PlanSuggestion?";
		if (e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (r += "query=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		r += "state=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPlanSuggestion(e)));
	}
	processPlanSuggestion(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t === 500) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	suburbSuggestion(e, t, n) {
		let r = this.baseUrl + "/SuburbSuggestion?";
		if (e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (r += "query=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		r += "state=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSuburbSuggestion(e)));
	}
	processSuburbSuggestion(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t === 500) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getTitleReference(e) {
		let t = this.baseUrl + "/GetTitleReference";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetTitleReference(e)));
	}
	processGetTitleReference(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t === 500) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getVendorDetails(e, t) {
		let n = this.baseUrl + "/GetVendorDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'propertyId' must be defined and cannot be null.");
		n += "propertyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: {},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetVendorDetails(e)));
	}
	processGetVendorDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (b(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 500) {
			let r = e.data;
			return y("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return y("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), v = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isRpDataApiException = !0;
	static isRpDataApiException(e) {
		return e.isRpDataApiException === !0;
	}
};
function y(e, t, n, r, i) {
	throw i ?? new v(e, t, n, r, null);
}
function b(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var x = "rpdata";
function S(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var C = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), S(r);
}, w = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[x] || `${e}/${x}`;
}, T = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = w(i), u = c, d = C(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(C(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, E = a({}), D = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = T(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(E.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, O = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(E), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["hasAccess"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.hasAccess(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, k = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["hasAccess"] });
	}, e[0] = t, e[1] = n), n;
}, A = (e, t, n, i, a, s, c, l, d, f) => {
	let p = r(29), m = f === void 0 ? !0 : f, h = o(E), g;
	p[0] !== l || p[1] !== d || p[2] !== s || p[3] !== a || p[4] !== e || p[5] !== t || p[6] !== n || p[7] !== c || p[8] !== i ? (g = [
		"getComparableProperties",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d
	], p[0] = l, p[1] = d, p[2] = s, p[3] = a, p[4] = e, p[5] = t, p[6] = n, p[7] = c, p[8] = i, p[9] = g) : g = p[9];
	let _ = g, v;
	p[10] !== h || p[11] !== l || p[12] !== d || p[13] !== s || p[14] !== a || p[15] !== e || p[16] !== t || p[17] !== n || p[18] !== c || p[19] !== i ? (v = (r) => {
		let { signal: o } = r;
		return h.getComparableProperties(e, t, n, i, a, s, c, l, d, o);
	}, p[10] = h, p[11] = l, p[12] = d, p[13] = s, p[14] = a, p[15] = e, p[16] = t, p[17] = n, p[18] = c, p[19] = i, p[20] = v) : v = p[20];
	let y = m && !!h, b;
	p[21] !== _ || p[22] !== v || p[23] !== y ? (b = {
		queryKey: _,
		queryFn: v,
		enabled: y
	}, p[21] = _, p[22] = v, p[23] = y, p[24] = b) : b = p[24];
	let { data: x, isPending: S, isError: C } = u(b), w;
	return p[25] !== x || p[26] !== C || p[27] !== S ? (w = {
		data: x,
		isPending: S,
		isError: C
	}, p[25] = x, p[26] = C, p[27] = S, p[28] = w) : w = p[28], w;
}, j = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l) => {
		await t.invalidateQueries({ queryKey: [
			"getComparableProperties",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l
		] });
	}, e[0] = t, e[1] = n), n;
}, M = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPropertySummary",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPropertySummary(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, N = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPropertySummary",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, P = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"addressSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.addressSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, F = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"addressSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, I = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"planSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.planSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, L = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"planSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, R = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"suburbSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.suburbSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"suburbSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, B = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(E), s;
	t[0] === a ? s = t[1] : (s = async () => a.getTitleReference(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getTitleReference: u,
		getTitleReferencePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, V = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(E), s;
	n[0] === e ? s = n[1] : (s = ["getVendorDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getVendorDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, H = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getVendorDetails", e] });
	}, e[0] = t, e[1] = n), n;
};
//#endregion
export { p as LandAreaDetailsTotalLandAreaType, h as PropertyDetailsBuiltOnOrVacantLandType, m as PropertyDetailsRuralType, g as PropertySuggestionItemState, E as RpDataApiContext, v as RpDataApiException, D as RpDataApiProvider, f as RpDataClient, x as RpDataRoute, _ as SuburbSuggestionItemState, P as useAddressSuggestion, A as useGetComparableProperties, M as useGetPropertySummary, B as useGetTitleReference, V as useGetVendorDetails, O as useHasAccess, F as useInvalidateUseAddressSuggestion, j as useInvalidateUseGetComparableProperties, N as useInvalidateUseGetPropertySummary, H as useInvalidateUseGetVendorDetails, k as useInvalidateUseHasAccess, L as useInvalidateUsePlanSuggestion, z as useInvalidateUseSuburbSuggestion, I as usePlanSuggestion, T as useRpDataClientContext, R as useSuburbSuggestion };
